/* eslint-disable import/prefer-default-export */
import { WidgetId } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useAppDispatch } from 'app/hooks'
import { setLoadMoreCursor } from 'features/widget/widgetSlice'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import CountType from 'enums/CountType'
import AnalysisType from 'enums/AnalysisType'

type StreamWidget = SocialWebStreamWidget | AudienceStreamWidget

export const useStreamWidgetLoadMoreInfo = <T extends StreamWidget>(widgetId: WidgetId) => {
  const widget = useDashboardWidgetData<T>(widgetId)
  const widgetSetting = useDashboardWidgetSetting<T>(widgetId)
  const { maxSoundbites } = widgetSetting

  let countType
  if (widgetSetting.analysisType === AnalysisType.AM_STREAM) {
    countType = CountType.MENTIONS
  } else {
    countType = (widgetSetting as SocialWebStreamWidget).countType!
  }

  const loadMoreCursor = widget?.loadMoreCursor ?? 0
  const dispatch = useAppDispatch()

  const handleLoadMore = () => {
    dispatch(
      setLoadMoreCursor({
        widgetId,
        loadMoreCursor: loadMoreCursor + maxSoundbites!
      })
    )
  }
  return {
    loadMoreCursor,
    maxSoundbites,
    handleLoadMore,
    countType
  }
}
